import Phaser from "phaser";

/**
 * Checks if running on iOS (iPhone / iPad / iPod / Safari).
 * Mobile Safari on iPhones explicitly blocks HTML5 Fullscreen API on elements.
 */
export function isIOS(): boolean {
  if (typeof window === "undefined" || typeof navigator === "undefined") return false;
  return (
    /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)
  );
}

/**
 * Checks if standard HTML5 Fullscreen API is supported by the browser.
 */
export function isFullscreenSupported(): boolean {
  if (isIOS()) return false;
  return !!(
    document.fullscreenEnabled ||
    (document as any).webkitFullscreenEnabled ||
    (document as any).mozFullScreenEnabled ||
    (document as any).msFullscreenEnabled
  );
}

/**
 * Toggles native HTML5 fullscreen on supported platforms (Android / Chrome / PC).
 * Safely no-ops on iPhone to prevent Safari viewport flickering.
 */
export function toggleFullscreen(scale: Phaser.Scale.ScaleManager): void {
  // On iOS (iPhone / Mobile Safari), native element fullscreen is blocked by Apple.
  // We safely noop to prevent Safari toolbar collapse/flicker.
  if (isIOS()) {
    console.info("Fullscreen API not supported on iPhone Safari. Use 'Add to Home Screen' for fullscreen mode.");
    return;
  }

  if (isFullscreenSupported() || scale.isFullscreen) {
    try {
      if (scale.isFullscreen) {
        scale.stopFullscreen();
      } else {
        scale.startFullscreen();
      }
    } catch (err) {
      console.warn("Fullscreen toggle failed:", err);
    }
  }
}
